// extracted by mini-css-extract-plugin
export default {"modal":"modal__vS8YH","calls":"calls__m7gHo","calls__filters":"calls__filters__Opqgs","calls__list":"calls__list__LW2Jt"};